import { Trans } from "@lingui/react/macro";
import React from "react";
import invariant from "tiny-invariant";

import { useCompany } from "@/common/providers/company-provider";
import { Failed } from "@/routes/shared/routes/failed/failed";

const CanISignContractGuard = ({ children }: React.PropsWithChildren) => {
  const { company } = useCompany();
  invariant(company);
  const canISign = company.grants.includes("CONTRACT_SIGN");

  if (canISign) {
    return <>{children}</>;
  }

  return (
    <Failed
      content={
        <Trans>Smlouvu může podepsat pouze uživatel s podpisovým právem</Trans>
      }
      title={<Trans>Nemáte právo k podpisu smlouvy</Trans>}
    />
  );
};

export { CanISignContractGuard };
